import React from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Avatar,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import EnquiryStats from "../components/enquiryStats";

const TeacherDashboard = () => {
  const navigate = useNavigate();

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : {};

  // Mock data for demonstration
  const teacherName = user?.name;
  const branchName = user?.branch;

  const getAvatarInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    return words.length === 1
      ? words[0][0].toUpperCase()
      : `${words[0][0]}${words[1][0]}`.toUpperCase();
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        // justifyContent: "space-between",
        minHeight: "100vh",
        py: 2,
      }}
    >
      {/* Teacher Info */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 2,
          padding: 2,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Avatar sx={{ width: 56, height: 56, marginRight: 2 }}>
          {" "}
          {getAvatarInitials(teacherName)}
        </Avatar>
        <Box>
          <Typography variant="h6">{teacherName}</Typography>
          <Typography variant="body2" color="textSecondary">
            {branchName}
          </Typography>
        </Box>
      </Box>

      {/* Actions Section */}
      <Box
        sx={{
          bottom: 0,
          backgroundColor: "#fff",
          py: 2,
          my: 2,
          textAlign: "center",
        }}
      >
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#3B82F6",
            padding: "0.75rem",
            fontWeight: "bold",
            textTransform: "none",
            marginBottom: 1,
            fontSize: "1rem",
          }}
          onClick={() => navigate("/enquiry/form")}
        >
          New Admission Enquiry
        </Button>
        <Button
          variant="outlined"
          fullWidth
          sx={{
            mt: 1,
            padding: "0.75rem",
            fontWeight: "bold",
            textTransform: "none",
            fontSize: "1rem",
          }}
          onClick={() => navigate("/enquiry/view")}
        >
          View Previous Enquiries
        </Button>
      </Box>

      <EnquiryStats />
    </Container>
  );
};

export default TeacherDashboard;
